// 비밀번호 기본정보 확인

import { useBaseCheckInfMutate } from "./service";
import { useBaseResetPwdParamContext } from "./context";

export const useResetPwd = () => {
  const { param } = useBaseResetPwdParamContext();
  const { mutate } = useBaseCheckInfMutate();
  const onSubmit = (form: HTMLFormElement) => {
    // ❌ validation 실패
    if (!form.checkValidity()) {
      form.reportValidity(); // required 문구 표시
      return;
    }

    mutate(param);
  };

  return {
    onSubmit,
  };
};
